/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Shortcut_Keys_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shortcut Keys" |
*
* @param {Toolbar_Secondary_Shortcut_Keys_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_shortcut_keys_aria_label = /** @type {((inputs?: Toolbar_Secondary_Shortcut_Keys_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Shortcut_Keys_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Touches de Raccourci")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tastenkombinationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tasti di scelta rapida")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сочетания клавиш")
	if (locale === "es") return /** @type {LocalizedString} */ ("Teclas de acceso directo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快捷键")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショートカットキー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉर्टकट कुंजियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Teclas de atalho")
	return /** @type {LocalizedString} */ ("Shortcut Keys")
});